import { create } from 'zustand';
import { User, AuthState } from '../models/User';

/**
 * Store global para autenticación
 * Similar a un Service en Angular
 */
interface AuthStore extends AuthState {
  // Actions
  login: (user: User) => void;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  // Estado inicial
  isLoggedIn: true, // Default para desarrollo
  user: {
    id: '1',
    name: 'Usuario',
    email: 'usuario@example.com',
  },

  // Acciones
  login: (user) => set({ isLoggedIn: true, user }),
  
  logout: () => set({ isLoggedIn: false, user: null }),
  
  updateUser: (userData) => set((state) => ({
    user: state.user ? { ...state.user, ...userData } : null,
  })),
}));
